import { IconGeeks } from '@shared/assets'
import { Typography } from '@shared/ui'
import styles from './Copyright.module.scss'
import { Link } from 'react-router-dom'

export const Copyright = () => {
  return (
    <div className={styles.copyright}>
      <Link 
        to='https://geeks.kg/'
        target='_blank'
        rel='noopener noreferrer'
      >
        <Typography 
          className={styles.text} 
          variant='bodyTextTwo'
          color='black'
        >
          MADE BY GEEKS
        </Typography>
      </Link>
      <IconGeeks/>
    </div>
  )
}
